import { useState } from 'react'
import { Alert, Button, Stack } from '@mui/joy'
import { DownloadSimple, Envelope } from '@phosphor-icons/react'
import { paymentsApi } from '../../lib/billingApi'
import SendReceiptModal from './SendReceiptModal'

/** Receipts are offered after the payment is saved; email always opens a review. */
export default function PaymentReceiptActions({ paymentId }: { paymentId: number }) {
  const [emailOpen, setEmailOpen] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const [error, setError] = useState('')

  const download = async () => {
    setDownloading(true)
    setError('')
    try {
      const blob = await paymentsApi.downloadReceipt(paymentId)
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `receipt-${paymentId}.pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(url)
    } catch {
      setError('The payment is saved, but the receipt could not be downloaded. Please try again.')
    } finally {
      setDownloading(false)
    }
  }

  return (
    <Stack spacing={1}>
      <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
        <Button size="sm" variant="outlined" startDecorator={<DownloadSimple />} loading={downloading} onClick={download}>
          PDF receipt
        </Button>
        <Button size="sm" variant="soft" startDecorator={<Envelope />} onClick={() => setEmailOpen(true)}>
          Email receipt
        </Button>
      </Stack>
      {error && <Alert color="danger" size="sm">{error}</Alert>}
      <SendReceiptModal open={emailOpen} paymentId={paymentId} onClose={() => setEmailOpen(false)} />
    </Stack>
  )
}
